import './sass/style.scss';
import './js/app.js';

import * as components0 from '../views/components/menu/horizontal/horizontal.js'; import * as components1 from '../views/components/searchform/index.js'; import * as components2 from '../views/components/slider/basic/index.js'; let components = [components0, components1, components2];
import * as blocks0 from '../views/blocks/Accordions/index.js'; import * as blocks1 from '../views/blocks/BannerSlider/index.js'; import * as blocks2 from '../views/blocks/Loadings/index.js'; import * as blocks3 from '../views/blocks/Offices/index.js'; import * as blocks4 from '../views/blocks/ProductsSlider/index.js'; import * as blocks5 from '../views/blocks/WorkersBlock/index.js'; let blocks = [blocks0, blocks1, blocks2, blocks3, blocks4, blocks5];
import * as woocommerce0 from '../views/woocommerce/archive-product/archive-product.js'; import * as woocommerce1 from '../views/woocommerce/components/AddedToCartPopup/added-to-cart-popup.js'; import * as woocommerce2 from '../views/woocommerce/components/ProductGallery/product-gallery.js'; import * as woocommerce3 from '../views/woocommerce/components/SidebarCart/sidebar-cart.js'; let woocommerce = [woocommerce0, woocommerce1, woocommerce2, woocommerce3];



document.addEventListener('DOMContentLoaded', function () {
    const texts = [
        'Umów spotkanie',
        'Umów pokaz',
        'Umów rozmowę'
    ];

    const textEl = document.getElementById('HeaderContactText');
    let index = 0;

    setInterval(() => {
        index = (index + 1) % texts.length;
        textEl.textContent = texts[index];
    }, 3000); // co 3 sekundy
});

